var map = {
	"./account.svg": [
		34650,
		"icons/icon-account-svg"
	],
	"./charges.svg": [
		89529,
		"icons/icon-charges-svg"
	],
	"./check.svg": [
		49132,
		"icons/icon-check-svg"
	],
	"./circle-dot.svg": [
		49640,
		"icons/icon-circle-dot-svg"
	],
	"./circle.svg": [
		26851,
		"icons/icon-circle-svg"
	],
	"./client.svg": [
		78877,
		"icons/icon-client-svg"
	],
	"./close.svg": [
		28371,
		"icons/icon-close-svg"
	],
	"./configuration.svg": [
		67002,
		"icons/icon-configuration-svg"
	],
	"./copy.svg": [
		88022,
		"icons/icon-copy-svg"
	],
	"./cred-card.svg": [
		41713,
		"icons/icon-cred-card-svg"
	],
	"./customers.svg": [
		5713,
		"icons/icon-customers-svg"
	],
	"./dashboard.svg": [
		16569,
		"icons/icon-dashboard-svg"
	],
	"./developer.svg": [
		17226,
		"icons/icon-developer-svg"
	],
	"./direction.svg": [
		12913,
		"icons/icon-direction-svg"
	],
	"./download.svg": [
		38645,
		"icons/icon-download-svg"
	],
	"./ellipsis.svg": [
		73438,
		"icons/icon-ellipsis-svg"
	],
	"./fees.svg": [
		38571,
		"icons/icon-fees-svg"
	],
	"./freearea.svg": [
		75370,
		"icons/icon-freearea-svg"
	],
	"./hub.svg": [
		28782,
		"icons/icon-hub-svg"
	],
	"./info.svg": [
		85041,
		"icons/icon-info-svg"
	],
	"./invites.svg": [
		41166,
		"icons/icon-invites-svg"
	],
	"./invoices.svg": [
		63147,
		"icons/icon-invoices-svg"
	],
	"./learn-more.svg": [
		74620,
		"icons/icon-learn-more-svg"
	],
	"./logoJPM.svg": [
		84589,
		"icons/icon-logoJPM-svg"
	],
	"./logs.svg": [
		92590,
		"icons/icon-logs-svg"
	],
	"./merchant.svg": [
		59325,
		"icons/icon-merchant-svg"
	],
	"./no-results.svg": [
		50570,
		"icons/icon-no-results-svg"
	],
	"./notification.svg": [
		6651,
		"icons/icon-notification-svg"
	],
	"./onboarding/greeting.svg": [
		97879,
		"icons/icon-onboarding-greeting-svg"
	],
	"./onboarding/navigation.svg": [
		522,
		"icons/icon-onboarding-navigation-svg"
	],
	"./onboarding/realTime.svg": [
		88312,
		"icons/icon-onboarding-realTime-svg"
	],
	"./onboarding/settings.svg": [
		60431,
		"icons/icon-onboarding-settings-svg"
	],
	"./orders.svg": [
		15862,
		"icons/icon-orders-svg"
	],
	"./pagarme.svg": [
		39003,
		"icons/icon-pagarme-svg"
	],
	"./payment-links.svg": [
		25811,
		"icons/icon-payment-links-svg"
	],
	"./payments.svg": [
		89869,
		"icons/icon-payments-svg"
	],
	"./permission.svg": [
		70598,
		"icons/icon-permission-svg"
	],
	"./pix-outline.svg": [
		22562,
		"icons/icon-pix-outline-svg"
	],
	"./pix.svg": [
		37255,
		"icons/icon-pix-svg"
	],
	"./plans.svg": [
		96433,
		"icons/icon-plans-svg"
	],
	"./profile.svg": [
		45355,
		"icons/icon-profile-svg"
	],
	"./recurrence.svg": [
		20135,
		"icons/icon-recurrence-svg"
	],
	"./security.svg": [
		7061,
		"icons/icon-security-svg"
	],
	"./shop.svg": [
		36906,
		"icons/icon-shop-svg"
	],
	"./statistics.svg": [
		3885,
		"icons/icon-statistics-svg"
	],
	"./subscription.svg": [
		9158,
		"icons/icon-subscription-svg"
	],
	"./subscriptions.svg": [
		4769,
		"icons/icon-subscriptions-svg"
	],
	"./test.svg": [
		99538,
		"icons/icon-test-svg"
	],
	"./trf.svg": [
		35692,
		"icons/icon-trf-svg"
	],
	"./users-solid.svg": [
		30940,
		"icons/icon-users-solid-svg"
	],
	"./users.svg": [
		14173,
		"icons/icon-users-svg"
	],
	"./webhooks-config.svg": [
		60730,
		"icons/icon-webhooks-config-svg"
	],
	"./webhooks-skeleton.svg": [
		84318,
		"icons/icon-webhooks-skeleton-svg"
	],
	"./webhooks.svg": [
		55335,
		"icons/icon-webhooks-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94970;
module.exports = webpackAsyncContext;